import React, { memo } from 'react'
import tw from 'twin.macro'
import { Tooltip, Typography } from '@mui/material'
import { GSIcon } from 'src/components/shared/GSIcon'
import { ContractorRecollection } from 'src/interfaces/contractor'
import { RecollectionTooltipContent } from './RecollectionTooltipContent'

interface CombinedRecollectionBadgeProps {
  manualRecollection: ContractorRecollection
  automaticRecollection: ContractorRecollection
  muted?: boolean
}

const CombinedRecollectionBadgeComponent = ({
  manualRecollection,
  automaticRecollection,
  muted = false,
}: CombinedRecollectionBadgeProps) => {
  const tooltipTitle = (
    <div css={tw`flex flex-col gap-4 w-full`}>
      <RecollectionTooltipContent recollection={automaticRecollection} />
      <RecollectionTooltipContent recollection={manualRecollection} />
    </div>
  )

  return (
    <Tooltip
      title={tooltipTitle}
      placement="bottom-start"
      slotProps={{
        tooltip: {
          sx: {
            width: 275,
            padding: '12px 16px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'flex-start',
            gap: '16px',
          },
        },
      }}
    >
      <div
        css={[
          tw`flex items-center gap-1 cursor-default hover:text-black`,
          muted ? tw`text-[#847E96]` : tw`text-black`,
        ]}
      >
        <GSIcon
          iconName="gs_arrows_repeat_right_left"
          width={20}
          height={20}
          stroke="currentColor"
        />
        <div css={tw`relative pr-2`}>
          <Typography variant="subtitle2" color="inherit" css={tw`font-semibold leading-none`}>
            A
          </Typography>
          <Typography
            variant="subtitle2"
            color="inherit"
            css={tw`font-semibold leading-none absolute -top-1.5 -right-0`}
          >
            M
          </Typography>
        </div>
      </div>
    </Tooltip>
  )
}

export const CombinedRecollectionBadge = memo(CombinedRecollectionBadgeComponent)
